<template>
  <div>
    <v-card width="100%" flat tile>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-btn color="grey lighten-2" class="black--text" @click="swap = !swap"
          >Change View</v-btn
        >
      </v-card-title>
      <v-card-text>
        <v-card outlined tile width="100%">
          <highcharts :options="HeatMap()"></highcharts>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Highcharts from "highcharts";
export default {
  props: ["data"],
  data() {
    return {
      swap: false,
    };
  },
  methods: {
    getPointCategoryName(point, dimension) {
      var series = point.series;
      var isY = dimension === "y";
      var axis = series[isY ? "yAxis" : "xAxis"];
      return axis.categories[point[isY ? "y" : "x"]];
    },
    HeatMap() {
      let vm = this;
      let chart = {
        chart: {
          type: "heatmap",
          marginTop: 40,
          marginBottom: 80,
          plotBorderWidth: 1,
          inverted: this.swap,
          style: {
            fontFamily: "Mitr",
          },
        },
        colors: ["#4064AC", "#00B900"],
        title: this.data.title,
        subtitle: this.data.subtitle,
        xAxis: {
          categories: this.data.xAxis,
          reversed: this.swap,
        },
        yAxis: {
          categories: this.data.yAxis,
          title: null,
          reversed: !this.swap,
        },
        accessibility: {
          point: {
            descriptionFormatter: function (point) {
              var ix = point.index + 1;
              var xName = vm.getPointCategoryName(point, "x");
              var yName = vm.getPointCategoryName(point, "y");
              var val = point.value;
              return ix + ". " + xName + " sales " + yName + ", " + val + ".";
            },
          },
        },
        colorAxis: {
          min: 0,
          minColor: "#FFFFFF",
          maxColor: Highcharts.getOptions().colors[0],
        },
        legend: {
          align: "right",
          layout: "vertical",
          margin: 0,
          verticalAlign: "top",
          y: 25,
          symbolHeight: 280,
        },
        tooltip: {
          formatter: function () {
            return (
              "<b>" +
              this.point.value +
              "</b> Customer in <br><b>" +
              vm.getPointCategoryName(this.point, "x") +
              "</b> at <br><b>" +
              vm.getPointCategoryName(this.point, "y") +
              "</b>"
            );
          },
        },
        series: [
          {
            name: "Sales per employee",
            borderWidth: 1,
            data: this.data.data,
            dataLabels: {
              enabled: true,
              color: "#000000",
            },
          },
        ],
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                yAxis: {
                  labels: {
                    formatter: function () {
                      return this.value.charAt(0);
                    },
                  },
                },
              },
            },
          ],
        },
      };
      return chart;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>